/**
 * `/auth/return` (TMMAPP-0003): centralized login lands here with the session cookie set. One
 * silent refresh turns it into a bearer, then the stashed deep link (or `/`) is replayed.
 */
import { useEffect, useRef } from 'react';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/auth/authHooks';
import { bootRefresh, popDeepLink } from '@/auth/silentRefresh';
import { HiddenPageTitle } from '@/shell/PageHeader';
import { StandaloneMain } from '@/shell/StandaloneMain';

export function AuthReturn() {
  const { t } = useTranslation();
  const { setAuthed } = useAuth();
  const navigate = useNavigate();
  // StrictMode double-invokes the mount effect; the refresh is issued once.
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    void bootRefresh().then((ok) => {
      if (ok) {
        setAuthed();
        void navigate(popDeepLink() ?? '/', { replace: true });
      } else {
        void navigate('/auth/error', { replace: true });
      }
    });
  }, [navigate, setAuthed]);

  return (
    <StandaloneMain sx={{ py: 6 }}>
      <HiddenPageTitle title={t('auth.signingIn')} />
      <Typography variant="body1" role="status">
        {t('auth.completing')}
      </Typography>
    </StandaloneMain>
  );
}
